export type TreeNodeId = number | string;

// eslint-disable-next-line @typescript-eslint/ban-types
export type TreeData<T extends Record<string, unknown> = {}> = {
  key: string;
  status?: string;
  virtual?: boolean;
  value: {
    id?: TreeNodeId;
    label?: React.ReactNode;
    name?: string;
    parentId?: number | null;
    status?: string;
    isActionable?: boolean;
  } & T; // Generic으로 확장된 부분
  children: TreeData<T>[]; // 자식 노드에도 동일한 generic 적용
};

export function buildIdToNodeMap(treeData: TreeData[]) {
  const idToNodeMap = new Map();

  function traverse(node: TreeData) {
    const nodeId = node.key.toString();
    idToNodeMap.set(nodeId, node);
    if (node.children && node.children.length > 0) {
      node.children.forEach(traverse);
    }
  }

  treeData?.forEach(traverse);
  return idToNodeMap as Map<TreeNodeId, TreeData>;
}

// 노드 추가 함수 (필요 X 서버에서 받아옴)
export function addNode(
  parentId: TreeNodeId,
  newNode: TreeData,
  idToNodeMap: Map<TreeNodeId, TreeData>,
) {
  const newNodeId = newNode.key.toString();

  const parentNode = idToNodeMap.get(parentId);
  if (!parentNode) {
    throw new Error(`Parent node with ID ${parentId} not found`);
  }

  parentNode.children = parentNode.children || [];
  parentNode.children.push({ ...newNode, virtual: true });
  idToNodeMap.set(newNodeId, newNode);
}

// 노드 삭제 함수 (필요 X 서버에서 받아옴)
export function removeNode(nodeId: TreeNodeId, idToNodeMap: Map<TreeNodeId, TreeData>) {
  const nodeToRemove = idToNodeMap.get(nodeId);
  if (!nodeToRemove) {
    throw new Error(`Node with ID ${nodeId} not found`);
  }

  const parentNode = nodeToRemove.value.parentId
    ? idToNodeMap.get(nodeToRemove.value.parentId)
    : null;
  if (parentNode) {
    parentNode.children = parentNode.children.filter((child: TreeData) => child.key !== nodeId);
  }

  idToNodeMap.delete(nodeId);
}

// 노드 수정 함수
export function updateNode(
  nodeId: string,
  updatedFields: Partial<TreeData>,
  idToNodeMap: Map<string, TreeData>,
) {
  const nodeToUpdate = idToNodeMap.get(nodeId);
  if (!nodeToUpdate) {
    throw new Error(`Node with ID ${nodeId} not found`);
  }

  Object.assign(nodeToUpdate, updatedFields);
}
